<template>
<div class="btn">
  <div class="more_button">
    <div>
      <a v-if="!loading" :href="button_href">{{button_text}}</a>
      <i v-else class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
    </div>
  </div>
</div>
  
</template>
<script>
export default {
  name: "moreButton",
  props: ["button_text", "button_href", "loading"]
};
</script>
<style>
.btn{
  max-width: 150px;
  margin: auto;
}
.more_button {
  margin: 20px 0 ;
}
.more_button div {
  width: 100%;
  height: 40px;
  font-weight: 700;
  text-align: center;
  line-height: 36px;
  margin: 0 auto;
  border: 2px solid #00a0e9;
    border-radius: 10px;
}
.more_button div a {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: #00a0e9;
  transition: all 0.5s;
  user-select: none;
}
.more_button div a:hover {
  color: white;
  background: #00a0e9;
}
.more_button div i {
  font-size: 21px;
  color: blue;
}
</style>